import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function AddEditDealModal({ show, setShow }) {
  return (
    <Modal show={show} onHide={() => setShow(false)} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add New Deals</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          <div className="col-12 mb-3">
            <Form.Label>Deal Name *</Form.Label>
            <Form.Select><option>Select</option></Form.Select>
          </div>

          <div className="col-md-6 mb-3 position-relative">
            <Form.Label>
              Pipeline * <span className="add-new">+ Add New</span>
            </Form.Label>
            <Form.Select><option>Select</option></Form.Select>
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Status *</Form.Label>
            <Form.Select><option>Select</option></Form.Select>
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Deal Value *</Form.Label>
            <Form.Control />
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Currency *</Form.Label>
            <Form.Select><option>Select</option></Form.Select>
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Period *</Form.Label>
            <Form.Select><option>Select</option></Form.Select>
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Period Value *</Form.Label>
            <Form.Control />
          </div>

          <div className="col-12 mb-3">
            <Form.Label>Contact *</Form.Label>
            <Form.Control defaultValue="Vaughan Lewis" />
          </div>

          <div className="col-12 mb-3">
            <Form.Label>Project *</Form.Label>
            <Form.Control defaultValue="Office Management App,Clinic Management,Educational Platform" />
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Due Date *</Form.Label>
            <Form.Control type="date" />
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Expected Closing Date *</Form.Label>
            <Form.Control type="date" />
          </div>

          <div className="col-12 mb-3">
            <Form.Label>Assignee *</Form.Label>
            <Form.Control defaultValue="Vaughan Lewis" />
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Tags *</Form.Label>
            <Form.Control defaultValue="Collab" />
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Followup Date *</Form.Label>
            <Form.Control type="date" />
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Source *</Form.Label>
            <Form.Select><option>Select</option></Form.Select>
          </div>

          <div className="col-md-6 mb-3">
            <Form.Label>Priority *</Form.Label>
            <Form.Select><option>Select</option></Form.Select>
          </div>

          <div className="col-12 mb-3">
            <Form.Label>Description *</Form.Label>
            <Form.Control as="textarea" rows={3} />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={() => setShow(false)}>
          Cancel
        </Button>
        <Button className="btn-orange">Add Deal</Button>
      </Modal.Footer>

      <style>
        {`
        .btn-orange {
          background: #f26522;
          border: none;
        }

        .add-new {
          color: #f26522;
          float: right;
          font-size: 12px;
          cursor: pointer;
        }

        .form-control:focus,
        .form-select:focus {
          border-color: #f26522;
          box-shadow: none;
        }
        `}
      </style>
    </Modal>
  );
}